import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Grid, ListItemButton } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListLinkValue } from "source/components/framework/List/ListLinkValue";
import { ListStateIconSuccess } from "source/components/framework/List/ListStateIconSuccess";
import { EllipsisTypography } from "source/components/framework/Typography/EllipsisTypography";
import { IRiskClassificationNode } from "ui/Scripts/source/models/risk/riskClassificationNode";

interface IRiskClassificationTreeNodeProp {
    level: number;
    item: IRiskClassificationNode;
    selectedId?: string;
    onClick: (id: string) => void;
    onDoubleClick: (id: string) => void;
    onSetCollapsed: (id: string, value: boolean) => void;
}

export const RiskClassificationTreeNode = (props: IRiskClassificationTreeNodeProp) => {
    const handleNodeClick = (e) => {
        e.stopPropagation();
        props.onClick(props.item.id);
    };
    
    const handleNodeDoubleClick = (e) => {
        e.stopPropagation();
        props.onDoubleClick(props.item.id);
    };

    const item = props.item;

    if (!item || item.parent && item.getAncesterIsCollapsed()) return null;
    
    const hasChildren = item.children.length > 0;
    
    const isActive = item.isActive();
    
    return (
        <>
            <ListItemButton
                selected={props.selectedId === item.id}
                onClick={handleNodeClick} onDoubleClick={props.onDoubleClick ? handleNodeDoubleClick : null}
                sx={{ bgcolor: !isActive ? "action.hover" : undefined, textDecoration: !isActive ? "line-through !important" : undefined }}
            >
                <Grid container>
                    <Grid item sm={5} sx={{ paddingLeft: (10 * props.level).toString(10) + "px" }}>
                        <Box display="flex" alignItems="center">
                            {hasChildren
                                ? (
                                    <>{item.collapsed
                                        ? (
                                            <ChevronRightIcon fontSize="small" onClick={hasChildren ? () => props.onSetCollapsed(item.id, !item.collapsed) : null} />
                                        )
                                        : (
                                            <ExpandMoreIcon fontSize="small" onClick={hasChildren ? () => props.onSetCollapsed(item.id, !item.collapsed) : null} />
                                        )}
                                    </>
                                )
                                : (
                                    <Box sx={{ width: "20px" }} />
                                )}
                            <ListLinkValue onClick={props.onDoubleClick ? handleNodeDoubleClick : null}>{item.code}</ListLinkValue>
                        </Box>
                    </Grid>
                    <Grid item sm={5}>
                        <EllipsisTypography>{item.comment}</EllipsisTypography>
                    </Grid>
                    <Grid item sm={2}>
                        {isActive &&
                            <ListStateIconSuccess tooltip={Translations.InUse} />
                        }
                    </Grid>
                </Grid>
            </ListItemButton>
            {item.children.map((childItem) =>
                <RiskClassificationTreeNode
                    key={childItem.id}
                    item={childItem}
                    level={props.level + 1}
                    selectedId={props.selectedId}
                    onClick={props.onClick}
                    onDoubleClick={props.onDoubleClick}
                    onSetCollapsed={props.onSetCollapsed}
                />
            )}
        </>
    );
};
